import { createDynamicThunk } from ".";

export const getDelegateAccesUserDetailThunk = createDynamicThunk({
  typePrefix: "getDelegateAccesUserDetailThunk",
  endpoint: "/fetchDelegateAccessUser",
  method: "POST",  
});

export const addDelegateAccessThunk = createDynamicThunk({
  typePrefix: "addDelegateAccessThunk",
  endpoint: "/addDelegateAccess",
  method: "POST",
  useHandleSearch: false,
});

export const undelegateAccessThunk = createDynamicThunk({
  typePrefix: "undelegateAccessThunk",
  endpoint: "/revokeDelegateAccess",
  method: "POST",
  useHandleSearch: false,
});